export default __webpack_public_path__ + "static/media/google_map.267fe013.png";